var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{staticClass:"wx-panel",attrs:{"type":"warning","icon":"mdi-alert-rhombus","outlined":"","text":""}},[_c('h2',{staticClass:"font-weight-regular"},[_vm._v(_vm._s(_vm.$t("404.title")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }